import type {
	createTransactionInput,
	getAllTransactionsInput,
	getTransactionInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllTransactions: getAllTransactionsInput;
	useCreateTransaction: createTransactionInput;
	useGetTransaction: getTransactionInput;
}

const TRANSACTIONS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"transactions",
	["useGetAllTransactions", "useCreateTransaction", "useGetTransaction"],
);

export { TRANSACTIONS_SERVICE_KEYS };
